import client from "../client";
import { InterventionTypeInterface } from "../../models/TicketModule/InterventionType";

class InterventionTypeService {
  async GetAll(page: number, pageSize: number) {
    try {
      let url = `/api/interventionTypes`;

      if (page > 0 && pageSize > 0) {
        url += `?page=${page}&pageSize=${pageSize}`;
      }
      const { data } = await client.get<InterventionTypeInterface[]>(url);
      return data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }

  async GetById(id: string) {
    try {
      let url = `/api/interventionTypes/getbyid/${id}`;

      const { data } = await client.get<InterventionTypeInterface>(url);

      return data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }

  async Save(interventionType: InterventionTypeInterface) {
    try {
      let url = `/api/interventionTypes`;

      const { data } = await client.post<InterventionTypeInterface>(
        url,
        interventionType
      );

      return data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }

  async Update(id: string, interventionType: InterventionTypeInterface) {
    try {
      let url = `/api/interventionTypes/update/${id}`;

      const { data } = await client.post<InterventionTypeInterface>(
        url,
        interventionType
      );

      return data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }
  async Remove(id: string) {
    try {
      let url = `api/interventionTypes/remove/${id}`;
      await client.post<InterventionTypeInterface>(url, { url: "" });
    } catch (error) {
      console.error(error);
      throw error;
    }
  }
}

export default new InterventionTypeService();
